import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { DocumentosService } from 'src/app/servicios/documentos.service';
import { Subject } from 'rxjs';
import { DTConfig } from 'src/app/Class/DTConfig ';
import { DataTableDirective } from 'angular-datatables';
import Swal from 'sweetalert2';
import { Loading } from 'src/app/Class/Loading';
import { DatePipe } from '@angular/common';
import { FuncionesJSService } from 'src/app/servicios/funciones-js.service';
declare var $: any;

@Component({
  selector: 'app-listado-documentos',
  templateUrl: './listado-documentos.component.html',
  styleUrls: ['./listado-documentos.component.css']
})
export class ListadoDocumentosComponent implements OnInit, OnDestroy {

  public dtTrigger: Subject<any> = new Subject();
  public dtOptions: any = Object.assign({}, DTConfig.dtConf);
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  botones: FuncionesJSService;

  public documentos: any = [];
  public archivo: string = null;
  public url: string = null;
  index: number;
  public documento: any = {
    palabras_clave: [],
    estamentos: [],
    facultades: [],
    normas: [],
    programas: [],
    unidades: [],
    };


  constructor( private documentoService: DocumentosService, public loading: Loading, private datePipe: DatePipe, private funciones: FuncionesJSService ) {

    this.loading.estado = true;
    this.botones = funciones;
    this.url = this.documentoService.getServe() ;

    this.documentoService.getDocumentos()
    .subscribe( data => {
      this.documentos = data['listado'];
      this.Botones();
      this.dtTrigger.next();
      this.loading.estado = false;
    },
    err => {  this.loading.estado = false; }
    );
  }

  ngOnInit() {}

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  verDetalle( datos ) {
    this.archivo =  datos['ruta'] ? this.url +  datos['ruta'] : null;
    datos['fecha_expedicion'] = datos['fecha_expedicion'] != null ? this.datePipe.transform(datos['fecha_expedicion'],"yyyy-MM-dd") : null; 
    datos['fecha_publicacion'] = datos['fecha_publicacion'] != null ? this.datePipe.transform(datos['fecha_publicacion'],"yyyy-MM-dd") : null; 
    this.documento = datos;
    $('#ModalDetalle').modal({ backdrop: 'static', keyboard: true, show: true });
   }

   publicarOcultar(id, i) {
     this.index = i;

     Swal.fire({
      title: 'Publicar/Ocultar',
      text: '¿Desea publicar/ocultar?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirmar',
      reverseButtons: true
    })
    .then((result) => {
      if (result.value) {
        this.documentoService.publicarOcultarD(id).subscribe(data => {
          if ( data ['success']) {
            this.documentos[i].publico = data['respuesta'];

            Swal.fire('Publicar', 'El estado se ha cambiado exitosamente', 'success' );
            this.rerender();
          } else {
            Swal.fire({ type: 'warning', title: 'No se pudo completar la solicitud', showConfirmButton: false, timer: 1500 });
          }
        });
      }
    });
  }


  Botones(){ 
    this.dtOptions.order = [[ 1, "asc" ]];
    this.dtOptions.dom = "Bfrtip";
    this.dtOptions.autoWidth = false;
    this.dtOptions.buttons = [
      {
        extend: 'copy',
        text: 'Copiar',
        exportOptions: { columns: [3, 4, 5, 0, 1, 2, 6, 8, 7] }
      },
      {
        extend: 'print',
        text: 'Imprimir',
        exportOptions: { columns: [3, 4, 5, 0, 1, 2, 6, 8, 7] }
      },
      {
        extend: 'excel',
        text: 'Excel',
        exportOptions: { columns: [3, 4, 5, 0, 1, 2, 6, 8, 7] }
      }
      
    ];
  }

}
